import { FileTypeEnum } from "api/documents";

export const documentLabels: Record<number, string> = {
  [FileTypeEnum.BulletinAdhesion]: 'DOCUMENT.LABELS.CONTRACT',
  [FileTypeEnum.BulletinAdhesionSigne]: 'DOCUMENT.LABELS.SIGNED_CONTRACT',
  [FileTypeEnum.CertificatAdhesion]: 'DOCUMENT.LABELS.CERTIFICATE',
  [FileTypeEnum.SimulationComplete]: 'DOCUMENT.LABELS.SIMULATION_DOCUMENTS',
  [FileTypeEnum.AdviceSheetPdfGenerer]: 'DOCUMENT.LABELS.ADVICE_SHEET',
  [FileTypeEnum.Ipid]: 'DOCUMENT.LABELS.IPID',
  [FileTypeEnum.Notice]: 'DOCUMENT.LABELS.NOTICE',
  [FileTypeEnum.AttestationSinistre]: 'DOCUMENT.LABELS.CLAIM',
  [FileTypeEnum.FicheProduit]: 'DOCUMENT.LABELS.PRODUCT',
  [FileTypeEnum.ConditionsSpeciales]: 'DOCUMENT.LABELS.SPECIAL_CONDITIONS',
  [FileTypeEnum.QuittanceGenerer]: 'DOCUMENT.LABELS.RECEIPT',
};
